export const lang = {
  home: "API",
  project: "API",
  encyclopedia: "DOC",
  quickStart: "快速开始",
  exploration: "深入探索",
  configuration: "配置文件",
  agreement: "协议文档",
  interface: "接口文档",
  download: "下载",
  community: "社区",
  login: "登录",
  register: "注册",
  logout: "注销",
  platformFeatures: "平台特性",
  platformTitle1: "分层异步开发模式",
  platformDescription1: "锐明新技术、新产品发布后，1周快速集成升级。",
  platformDescription4: "对自己的开发内容具备完整的知识产权",
  platformTitle2: "丰富的基础技术能力",
  platformDescription2: "相比完整的软硬件开发，节省90%的开发投入",
  platformTitle3: "完善的研发文档",
  platformTitle4: "丰富的模板代码库",
  platformDescription3: "降低开发难度，C/C++人员快速上手",
  hardwareProducts: "硬件产品",
  vehicleTerminals: "车载终端",
  webcams: "网路摄像机",
  intelligentDevices: "智能设备",
  camera: "摄像头",
  more: "更多",
  applications: "应用案例",
  general: "通用",
  generalExamples: "锐明技术通用对接案例",
  transitBus: "公交",
  transitBusExamples: "锐明技术公交对接案例",
  passengersDanger: "两客一危",
  passengersDangerExamples: "锐明技术两客一危对接案例",
  taxi: "出租",
  taxiExamples: "锐明技术出租对接案例",
  AI: "AI",
  AIExamples: "锐明技术AI对接案例",
  siteMap: "站点导航",
  quickEntrance: "快速入口",
  streamaxWebsite: "锐明官网",
  aboutUS: "关注我们，了解锐明!",
  supplierPlatform: "供应商平台",
  supplierSelf: "供应商自荐",
  supplierIntroduction: "供方导入介绍",
  tenderManagement: "招标管理",
  streamaxTechnology: "深圳市锐明技术股份有限公司",
  rightsReserved: "粤ICP备10239636号",
  stockCode: "股票代码：",
  downloadInformation: "资料下载",
  SDKContent: "完整的SDK开放内容，配套的软硬件资料",
  searchProduct: "搜索产品",
  searchKeyword: "请输入你要搜索的关键词",
  tools: "工具",
  compilers: "编译器",
  burningTools: "烧录工具",
  view: "查看",
  firmware: "开发包 & 固件",
  basicVersion: "开发包",
  busVersion: "公交版本",
  files: "文档",
  productSpecification: "产品规格书",
  operatingManuals: "操作手册",
  handbook: "手册",
  A8PRODescription:
    "A8PRO产品由3.5英寸硬盘模块、主机模块、通讯和电源模块等组成，是具有业务调度、视频播放、语音播报、司机考勤、业务传感器互联等功能的硬盘智能监控调度一体机。",
  ADPLUSDescription:
    "ADPLUS是一款内置AI处理器的高级仪表板摄像头，可以检测车道偏离、向前碰撞等驾驶事件，以及使用手机和不系安全带等驾驶员行为。它可以实时提醒司机的危险行为，并将事件上传到监控平台，由车队经理审查，以帮助他们指导司机降低风险。",
  M1NDescription:
    "M1N是专为车载视频监控、远程视频监控开发的一款高性价比、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合IT领域中最先进的H.265视频压缩/解压缩技术、GPS/BD定位技术。设备可实现1080P、720P、WD1、WHD1、WCIF、D1、HD1、CIF分辨率录像。产品支持扩展AI功能，可实现高级驾驶辅助(ADAS)警报、BSD盲区检测和DSM驾驶员状态监管，产品有效提高驾驶员安全驾驶和减少人车交通事故。",
  X3NAIDescription:
    "X3N-AI是专为车载视频监控、远程视频监控开发的一款高性价比、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合IT领域中最先进的H.265视频压缩/解压缩技术、4G/3G网络技术、GPS/BD定位技术、WIFI技术。可实现1080P、720P、WD1、WHD1、WCIF、D1、HD1、CIF分辨率录像，汽车行驶信息记录和远程视频上传，配合中心软件可实现报警联动的中央远程视频监控、车辆智能调度管理及基于中心数据库的回放分析。产品具有抗振能力强、防电磁干扰、防辐射、外观简洁、安装灵活方便、功能全面、硬盘存储、SD卡备份设计、可靠性高等特点。产品支持扩展AI功能，可实现高级驾驶辅助(ADAS)警报、BSD盲区检测和DSM驾驶员状态监管，有效提高驾驶员安全驾驶和减少人车交通事故。",
  X5NAIDescription:
    "X5N-E0804是专为车载视频监控、远程视频监控开发的一款高性价比、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合IT领域中最先进的H.265视频压缩 / 解压缩技术、4G/3G/WIFI无线网传技术、GPS/北斗卫星定位技术等。采用最新的处理器方案，可实现1080P、720P、WD1、WHD1、WCIF、D1、HD1、CIF分辨率录像，车辆各项状态数据和监控数据实时本地记录和无线上传，配合中心软件实现了报警联动、证据中心、远程管理、录像回放、轨迹分析等专业功能，具有可靠性高，安装灵活和维护方便等特点。产品支持扩展AI功能，可实现高级驾驶辅助(ADAS)警报、BSD盲区检测和DSM驾驶员状态监管，有效提高驾驶员安全驾驶和减少人车交通事故。",
  gdbTools: "gdb工具",
  tcpdumpTools: "tcpdump工具",
  searchFile: "搜索文档内容",
  previous: "上一篇",
  next: "下一篇",
  updateTime: "更新时间",
  accountLogin: "账号登录",
  accountPlaceholder: "请输入账号",
  passwordPlaceholder: "请输入密码",
  forgetPassword: "忘记密码?",
  concatAdministrators: "忘记密码请联系相对应的管理员",
  close: "关闭",
  compilerScript: "编译器脚本",
  unpackScript: "打包拆包脚本",
  upgradePack: "升级包",
  AIBOXDescription:
    "车载智能终端AIBOX 5.0是一款先进的驾驶安全管理终端，通过人工智能算法对驾驶员异常驾驶行为检测识别，对驾驶员抽烟、打电话、疲劳驾驶、单手离把、双手离把及未系安全带等异常行为予以告警。同时，通过人工智能算法对前方车辆、车道、行人、斑马线等特征进行检测识别，有效预测前车碰撞、车道偏离、行人碰撞、礼让行人等危险或违规行为，并对此行为进行智能分析从而全面减少此类原因引起的交通事故。本套产品支持独立通讯、定位及存储，支持获取车辆CAN总线数据，适用于白天、夜晚和雨雪等大部分天气条件。",
  tutorials: "课堂",
  X1NAIDescription:
    "X1N是专为车载视频监控、远程视频监控开发的一款高性价比、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合IT领域中最先进的H.265视频压缩/解压缩技术、4G/3G网络技术、GPS/BD定位技术、WIFI技术。X1N-H0401可实现1080P、720P、WD1、WHD1、WCIF、D1、HD1、CIF分辨率录像，汽车行驶信息记录和远程视频上传，配合中心软件可实现报警联动的中央远程视频监控、车辆智能调度管理及基于中心数据库的回放分析。产品支持扩展AI功能，可实现高级驾驶辅助(ADAS)警报、BSD盲区检测和DSM驾驶员状态监管，有效提高驾驶员安全驾驶和减少人车交通事故。",
  C6D5Description:
    "锐明智能服务终端 C6D(V5.0)是一款具备智能识别的车载智能终端产品，通过终端自带的 摄像头可实现对驾驶员离线人脸识别，有效实现驾驶员违规营运监管；同时通过终端扩展接 口外接锐明智能摄像机能够实现驾驶员抽烟、打电话、疲劳驾驶、分心等异常行为检测和提 醒，从而全面减少不安全驾驶行为引起的交通事故。此外，该套系统能够完全满足网约出租车的标准功能要求，相关营运、定位、音视频数据能够上传到后端平台，便于交通管理部门和相关企业单位对车辆营运过程进行监控管理。软硬件高度集成，DMS/ADAS 一体化;默认支持 4 路方案，最大可支持 5 路方案;支持司机离线人脸识别；3G/4G、GPS/BD、WIFI 等功能集于一体，方便安装；支持 2 路 TF 卡录像存储，最大支持 256GB，并具有防盗功能；特殊的文件系统，保护车内乘客隐私；工业化设计要求，铝合金外壳，大面积散热齿，散热效果好；产品小巧、重量轻，后视镜后方玻璃上粘贴安装，方便快捷，不遮挡司机视线；对内 720P 摄像头具有红外功能，可清晰拍摄到车内司机及前后排乘客，保障司机、乘客安全；对外 1080P 摄像头可清晰拍摄到车外场景，为您还原事实真相，让交警现场定责，快速处理事故；司机报警按钮，隐蔽安装，司机长按报警可向后台报警，保障司机安全；",
  gui: "GUI",
  X7V3Description:
    "X7 SE-H0808  是专为车载视频监控、远程视频监控开发的一款性价比高、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合 IT 领域中最先进的 H.265 视频压缩/解压缩技术、4G/3G 网络技术、GPS/BD 定位技术、WIFI 技术。可实现 1080P、720P 分辨率录像，汽车行驶信息记录和远程视频上传，配合中心软件可实现报警联动的中央远程视频监控、车辆智能调度管理及基于中心数据库的回放分析。产品具有抗振能力强、防电磁干扰、防辐射、外观简洁、安装灵活方便、功能全面、双硬盘存储、SD 卡备份设计、可靠性高等特点。",
  ADPRO2Description:
    "ADpro 2.0 是一款高度集成的整机，集成主动防撞告警、驾驶员异常行为告警系统、报警提示器及行车记录仪功能。通过摄像头和人工智能算法对前方车辆、车道、交通场景进行检测识别，再结合对车辆运动状态和驾驶员行为的分析，有效预测前车碰撞、车道偏离等危险，并对驾驶员抽烟、打电话、疲劳驾驶、分心等异常行为予以告警，从而全面减少此类原因所引起的交通事故。结合视频压缩/解压缩技术、3G/4G 网络技术、GPS/BD定位技术。可实现录像，汽车行驶信息记录和远程视频上传，配合中心软件可实现报警联动的中央远程视频监控与基于中心数据库的回放分析。",
  case: "场景案例",
  X7V4Description:
    "X7v4是专为车载视频监控、远程视频监控开发的一款性价比高、功能可扩展性好的设备。它采用高速处理器和嵌入式操作系统，结合IT领域中最先进的H.265视频压缩/解压缩技术、4G/3G网络技术、GPS/BD定位技术、WIFI技术。可实现1080P、720P分辨率录像，汽车行驶信息记录和远程视频上传，配合中心软件可实现报警联动的中央远程视频监控、车辆管理及基于中心数据库的回放分析。产品具有抗振能力强、防电磁干扰、防辐射、外观简洁、安装灵活方便、功能全面、双硬盘存储、SD卡备份设计、可靠性高等特点。",
  network: "网络协议",
  helpCenter: "帮助中心"
};
